// We're missing the import of font-awesome, but its styles are being imported in `application.css`
import "~/javascripts/react/utils/timeframes"
import "~/javascripts/appsignal"
import "~/javascripts/appsignal-browser"
import "~/javascripts/intercom"
import "~/javascripts/react/start"
import "~/javascripts/rails/app/billing"
import "~/javascripts/rails/shared/diagnose_reports"
import "~/javascripts/rails/app/notifier_subscription"
import "~/javascripts/rails/shared/flash"
import "~/javascripts/rails/app/geckoboard"
import "~/javascripts/rails/shared/header"
import "~/javascripts/rails/app/members"
import "~/javascripts/rails/app/notifiers"
import "~/javascripts/rails/shared/save_loading_indicator"
import "~/javascripts/rails/app/security"
import "~/javascripts/rails/shared/sidebar"

window.loadIntercom()
